export default function isWarning(status) {
  return status === 'warning';
}
